import React from "react";

const PatientDetailsSectionFilters = ({
  onSectionToggle,
  selectedSections,
}) => {
  const sections = [
    {
      id: "treatmentDetails",
      label: "Treatment Details",
      count: 4,
      checked: true,
      icon: "medical_services",
    },
    { id: "notes", label: "Notes", count: 2, checked: true, icon: "note_alt" },

    {
      id: "laboratory",
      label: "Laboratory",
      count: 3,
      checked: true,
      icon: "science",
    },
    {
      id: "diagnosticImaging",
      label: "Diagnostic Imaging",
      checked: true,
      icon: "radiology",
    },

    {
      id: "medicalRecord",
      label: "Medical Record",
      checked: true,
      icon: "folder_shared",
    },
    {
      id: "molecularMedicine",
      label: "Molecular Medicine",
      checked: true,
      icon: "biotech",
    },

    {
      id: "appointments",
      label: "Appointments",
      checked: true,
      icon: "calendar_today",
    },
    {
      id: "prescriptions",
      label: "Prescriptions",
      checked: true,
      icon: "medication",
    },
    { id: "allergies", label: "Allergies", checked: true, icon: "warning" },
    {
      id: "immunizations",
      label: "Immunizations",
      checked: true,
      icon: "vaccines",
    },
    {
      id: "electronicPrescriptions",
      label: "Electronic Prescriptions",
      checked: true,
      icon: "receipt",
    },
    { id: "orders", label: "Orders", checked: true, icon: "shopping_cart" },
    {
      id: "medicalConsent",
      label: "Medical Consent",
      checked: true,
      icon: "gavel",
    },
    {
      id: "nursing",
      label: "Nursing",
      checked: true,
      icon: "health_and_safety",
    },
    {
      id: "patientVitals",
      label: "Patient Vitals",
      checked: true,
      icon: "monitor_heart",
    },

    { id: "teamChat", label: "Team Chat", checked: true, icon: "chat" },
    {
      id: "treatmentTimeline",
      label: "Treatment Timeline",
      checked: true,
      icon: "timeline",
    },
  ];

  const handleCheckboxChange = (sectionId) => {
    onSectionToggle(sectionId);
  };

  return (
    <ul
      className="d-grid gap-2 mb-4"
      style={{ gridTemplateColumns: "repeat(5, 1fr)" }}
    >
      {sections.map((section) => (
        <li
          key={section.id}
          className="d-flex gap-2 bg-white p-3 shadow-sm rounded-10"
        >
          <div className="form-check p-0 d-flex flex-fill align-items-center gap-2 fs-sm text-gray m-0 cursor-pointer rounded-8">
            <input
              type="checkbox"
              name={section.id}
              id={section.id}
              className="form-check-input flex-shrink-0 bg-transparent border-2 border-gray-600 shadow-none m-0"
              checked={selectedSections[section.id]}
              onChange={() => handleCheckboxChange(section.id)}
            />
            <span className="material-symbols-outlined icon-sm text-primary me-1">
              {section.icon}
            </span>
            <label
              className="d-block lh-1 cursor-pointer form-check-label"
              htmlFor={section.id}
            >
              {section.label}
            </label>
          </div>
          {section.count && (
            <span
              className="d-flex align-items-center justify-content-center bg-secondary fs-sm text-white rounded-circle"
              style={{ width: "1.25rem", height: "1.25rem" }}
            >
              {section.count}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default PatientDetailsSectionFilters;
